import { CtaButton, Spinner } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledBodyText = styled.h1`
  font-size: ${rem('16px')};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.cross.deepBlu};
`;

export const StyledButton = styled(CtaButton)`
  cursor: pointer;
  display: flex;

  &:not(:first-child) {
    margin-left: ${rem('12px')};
  }
`;

export const StyledSpinner = styled(Spinner)`
  margin-right: ${rem('5px')};
`;

export const StyleButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.s}) {
    justify-content: space-between;
  }
`;
